export type EventInfoPreviewProperty = 'ownerFirstName' | 'fianceeFirstName' | 'location' | 'eventDate' | 'greeting';

export type EventStylePreviewProperty =
  | 'layout'
  | 'theme'
  | 'color'
  | 'font'
  | 'template'
  | 'suggestedColor'
  | 'assetId'
  | 'backgroundType'
  | 'enableBackgroundTranslucency'
  | 'coverPhoto';

export type PreviewProperty = EventInfoPreviewProperty | EventStylePreviewProperty | 'currentPageType';

export enum PreviewInitializationSource {
  searchParams = 'searchParams',
  onInitialized = 'onInitialized'
}

export type PreviewActions = PreviewInitializationSource | PreviewProperty | 'fromList';

export enum PreviewInternalAction {
  previewInitialized = 'previewInitialized'
}

export type PreviewKeyValue = {
  key: PreviewProperty;
  value: string | boolean;
};

export type PreviewMessage = {
  action: PreviewActions;
  value: PreviewKeyValue[] | PreviewKeyValue['value'];
};
